module.exports = __webpack_public_path__ + "files/f9a79222cec314051cd59c9f660c64a5.png";